var mzg;
if (!mzg) {
    mzg = {};
}

$.extend(mzg,
    /**
     * @lends mzg
     */
    {
        /**
         * @namespace
         * @description Header Scroll Function
         */
        header: {
            /**
             * @type {function}
             * @description initialize Header
             */
            init: function () {               
                var $window = $(window),
                    $header = $('.header'),
                    top = $header.height();

                FastClick.attach(document.body);
                
                $(window).on( 'DOMMouseScroll mousewheel', function ( event ) {
                    if( event.originalEvent.detail > 0 || event.originalEvent.wheelDelta < 0 ) { 
                        if( $window.scrollTop() > top) {
                            $header.addClass('header--pageScrolled');
                        }
                    } else {
                        if( $window.scrollTop() < 750) {
                            $header.removeClass('header--pageScrolled');
                        }
                    }
                });

                $('body').scrollspy({ target: '#sidenav', offset: 350 });
                
                $(function() {
                    $(window).resize();
                });
                
                $('.mobile-tab-select').on('change',function(){                    
                    $('[href="#'+$(this).val()+'"]').tab('show');
                });

                //clone menu for mobile menu - has to be clone before dmenu init
                             

                //console.log($("#mobileMenu").find('.hiddenSubLevel2 SubmenuMega').children('> a').length > 0);
                
                $('#menu').dmenu({
                    menu 	: {
                        logo			: true
                    },
                    item: {
                        bg				: false,
                        border 			: false,
                        subindicator	: false,

                        fit: [
                            {
                                items 		: null,
                                fitter 		: 'icon-hide',
                                order		: 'all'
                            },
                            {
                                items 		: null,
                                fitter 		: 'icon-only',
                                order		: 'all'
                            },
                            {
                                items 		: ':not(.dm-item_align-right)',
                                fitter 		: 'submenu',
                                order		: 'rtl'
                            },
                            {
                                items 		: ':not(.dm-item_align-right)',
                                fitter 		: 'hide',
                                order		: 'rtl'
                            }
                        ]
                    },
                    submenu: {
                        arrow			: false,
                        border			: false,
                        shadow			: true
                    },
                    subitem: {
                        bg				: true,
                        border			: false
                    }

                });
                
                //IE flebox bug fix
                var ua = window.navigator.userAgent;
                var msie = ua.indexOf("Trident");
                if (msie > 0) {
                    $('.nav-level-2 .dm-item_submenu-mega ul').removeClass('flex-column');
                }
            }
        }
    }
);

$(mzg.header.init);
